<template>
  <div :style="cssProps">
    <div
      class="text-black font-normal relative rounded-large p-4 md:py-8 md:px-20 mr-boxOffset mb-boxOffset
      before:bg-brightBlue before:absolute before:w-full before:h-full before:top-boxOffset before:left-boxOffset before:rounded-large
      before:border-3 before:border-solid before:border-black before:box-border
      after:bg-white after:absolute after:w-full after:h-full after:top-0 after:left-0 after:rounded-large
      children:z-10 children:relative"
      :class="{'before-bg-colour': !!colour, 'after:bg-lightGray': gray}"
    >
      <div class="text-center px-iconOffset text-hero">
        <span class="inline-flex items-baseline -ml-iconOffset mr-iconGap text-hero w-iconSize h-iconSize">
          <slot name="icon" />
        </span>

        <h1 class="inline font-display font-normal text-hero leading-hero mb-0 mx-auto">
          <slot name="heading" />
        </h1>
      </div>

      <div class="w-full max-w-3xl mx-auto my-6 text-center">
        <slot />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps } from 'vue'

const props = defineProps({
  colour: String,
  gray: Boolean
})

const cssProps = computed(() => ({
  '--colour': props.colour
}))
</script>

<style scoped>
.before-bg-colour::before {
  background: var(--colour);
}
</style>
